export default __webpack_public_path__ + "static/media/Wheel-Center-Spin-Button.de955e06.png";